import AgedDebtorReport from './requirementTypes/AgedDebtorReport';
import BusinessPlan from './requirementTypes/BusinessPlan';
import CompanyAccounts from './requirementTypes/CompanyAccounts';
import ManagementAccounts from './requirementTypes/ManagementAccounts';
import VATReturns from './requirementTypes/VATReturns';
import styles from './TradingHistory.module.css';
import { GetProductOffersResponse } from '@iwoca/lapi-client/edge';
import { TRecursiveNonNullable } from '@api/Helper.types';

export type TGetProductOffersResponseData =
    TRecursiveNonNullable<GetProductOffersResponse>['data'];

const TradingHistory = ({
    optionalDocs
}: {
    optionalDocs: TGetProductOffersResponseData['products'][number]['data_requirements'];
}) => {
    const DOCUMENT_REQUIREMENTS: { [key: string]: React.ElementType } = {
        company_accounts: CompanyAccounts,
        management_accounts: ManagementAccounts,
        business_plan: BusinessPlan,
        aged_debtor_report: AgedDebtorReport,
        vat_return: VATReturns
    };

    const renderDocumentRequirements = (
        requirements: TGetProductOffersResponseData['products'][number]['data_requirements']
    ) => {
        return requirements.map((requirement) => {
            if (!DOCUMENT_REQUIREMENTS[requirement.type]) {
                return null;
            }

            const RequirementDetails = DOCUMENT_REQUIREMENTS[requirement.type];
            return (
                <RequirementDetails
                    key={requirement.type}
                    isOptional={requirement.is_optional}
                    quantifier={requirement.quantifier}
                    resolutionMethods={requirement.resolution_methods}
                    status={requirement.status}
                />
            );
        });
    };

    return (
        <>
            <h4 className={styles.title}>
                Want to add extra documents? <span>(Optional)</span>
            </h4>
            <p
                className={styles.description}
                data-testid="optional-doc-description"
            >
                These aren't mandatory, but including more information would
                help us get a clearer picture of your business.
            </p>
            {renderDocumentRequirements(
                optionalDocs as TGetProductOffersResponseData['products'][number]['data_requirements']
            )}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default TradingHistory;
